export const MILLISECONDS_PER_DAY = 86400 * 1000

const MONTH_NAMES = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
]

export function getMonthName(date = new Date()) {
    return MONTH_NAMES[date.getMonth()]
}

export function startOfYear(date = new Date()) {
    if (date === null || date === undefined) {
        return null
    }

    return new Date(date.getFullYear(), 0, 1)
}

export function startOfMonth(date = new Date()) {
    if (date === null || date === undefined) {
        return null
    }

    return new Date(date.getFullYear(), date.getMonth(), 1)
}

export function startOfDay(date = new Date()) {
    if (date === null || date === undefined) {
        return null
    }

    return new Date(date.getFullYear(), date.getMonth(), date.getDate())
}

export function nextWeekday(day, date = new Date()) {
    date = startOfDay(date)

    const actual = date.getDay()

    if (actual === day) {
        return date
    }

    return actual < day ? addDays(day - actual, date) : addDays(day - actual + 7, date)
}

export function treatUtcAsLocal(date) {
    if (date === null || date === undefined) {
        return null
    }

    // same date, but treated as local
    return new Date(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate(),
        date.getUTCHours(),
        date.getUTCMinutes(),
        date.getUTCSeconds(),
        date.getUTCMilliseconds()
    )
}

export function addSeconds(seconds, date = new Date()) {
    date = new Date(date)
    return new Date(date.valueOf() + seconds * 1000)
}

export function addDays(days, date = new Date()) {
    return addSeconds(days * 86400, date)
}

export function addMonths(months, date = new Date()) {
    date = new Date(date)
    months = Math.trunc(months)

    // figure out the target month
    const targetMonth = (((date.getMonth() + months) % 12) + 12) % 12

    date.setMonth(date.getMonth() + months)

    // if we didn't land in the target month, we rolled over
    // because there weren't enough days in the target month
    // use -1 to set to the last day of the previous month
    if (targetMonth !== date.getMonth()) {
        date.setDate(-1)
    }

    return date
}

export function addYears(years, date = new Date()) {
    date = new Date(date)
    years = Math.trunc(years)

    // month should be preserved; if not, we rolled past the end of the month
    // this only happens for February 29th when moving by years
    const month = date.getMonth()

    date.setFullYear(date.getFullYear() + years)

    if (month !== date.getMonth()) {
        date.setDate(-1)
    }

    return date
}

export function add(value, unit, date = new Date()) {
    switch (unit) {
        case 'day':
        case 'days':
            return addDays(value, date)
        case 'month':
        case 'months':
            return addMonths(value, date)
        case 'year':
        case 'years':
            return addYears(value, date)
    }
}

export function dateDiff(first, second) {
    return (second.getTime() - first.getTime()) / 86400 / 1000
}

export function unixSeconds(date) {
    if (date === null || date === undefined) {
        return null
    }

    if (!date.getTime) {
        date = new Date(date)
    }

    return date.getTime() / 1000
}
